import {useParams} from "react-router-dom";
import NewStudio from "../NewStudio/NewStudio";
import {useContext, useEffect} from "react";
import {AuthContext} from "../../context/AuthContext";
import {LibrettoRecordingMode} from "../../utils/utils";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "../../Firebase";
import {kRoomStateCollectionName} from "../../utils/CollectionConstants";


export const RecordAudio = () => {

    const {optionalProjectId, initialAssetId} = useParams();

    const authContext = useContext(AuthContext);

    const roomName = authContext.getUserRoomName();

    const userChoices = {
        username: authContext.getUserDisplayName(),
        title: "My Audio Recording",
        audioEnabled: true,
        videoEnabled: false,
    }

    useEffect(() => {
        const updateRecordingMode = async () => {

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {recordingType: LibrettoRecordingMode.Audio});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        updateRecordingMode().then(() => {
            console.log('updateRecord mode success');
        }).catch(error => {
            console.error('Error updating recording mode: ', error);
        })

    }, []);

    return (
        <NewStudio isSoloRecording={true} projectId={optionalProjectId} initialAssetId={initialAssetId} userChoices={userChoices}/>
    )

}

export const RecordCamera = () => {

    const {optionalProjectId, initialAssetId} = useParams();

    const authContext = useContext(AuthContext);

    const roomName = authContext.getUserRoomName();

    const userChoices = {
        username: authContext.getUserDisplayName(),
        title: "My Camera Recording",
        audioEnabled: true,
        videoEnabled: true,
    }

    useEffect(() => {
        const updateRecordingMode = async () => {

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {recordingType: LibrettoRecordingMode.Video});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        updateRecordingMode().then(() => {
            console.log('updateRecord mode success');
        }).catch(error => {
            console.error('Error updating recording mode: ', error);
        })

    }, []);

    return (
        <NewStudio isSoloRecording={true} projectId={optionalProjectId} initialAssetId={initialAssetId} userChoices={userChoices}/>
    )

}

export const RecordScreen = () => {

    const {optionalProjectId, initialAssetId} = useParams();

    const authContext = useContext(AuthContext);

    const userChoices = {
        username: authContext.getUserDisplayName(),
        title: "My Screen Recording",
        audioEnabled: true,
        videoEnabled: true,
    }

    const roomName = authContext.getUserRoomName();

    useEffect(() => {
        const updateRecordingMode = async () => {

            const entityRef = doc(db, kRoomStateCollectionName, roomName);
            try {
                await updateDoc(entityRef, {recordingType: LibrettoRecordingMode.Video});
            } catch (error) {
                console.error('Error updating recording type for room: ', error);
            }
        }

        updateRecordingMode().then(() => {
            console.log('updateRecord mode success');
        }).catch(error => {
            console.error('Error updating recording mode: ', error);
        })

    }, []);

    return (
        <NewStudio isSoloRecording={true} projectId={optionalProjectId} initialAssetId={initialAssetId} userChoices={userChoices} screenShareInitiallyEnabled={true}/>
    )

}